import { lazy, Suspense } from 'react';

const LazyMemberRegister = lazy(() => import('./MemberRegister'));

const MemberRegister = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => (
  <Suspense fallback={null}>
    <LazyMemberRegister {...props} />
  </Suspense>
);

export default MemberRegister;
